/**
 * Compare two dates without time
 * @param {Date} first First date param to comparison
 * @param {Date} second Second date param to comparison
 */
const compareDate = (first, second) =>
  first?.toDateString() === second?.toDateString()

export default compareDate
